<template>
  <div class="join-page">
    <!-- กำลังบันทึก -->
    <div v-if="page === 'loading'" class="join-card">
      <!-- สำเร็จแล้ว: นกวนต่อให้ครบรอบ จางหาย แล้วค่อยขึ้นการ์ดสำเร็จ -->
      <bird-orbit :size="140" :finishing="finishing" class="join-orbit" @done="page = 'joinmeet'"></bird-orbit>
      <div class="join-loading">กำลังลงทะเบียน...</div>
    </div>

    <!-- ลงทะเบียนสำเร็จ -->
    <div v-else-if="page === 'joinmeet'" class="join-card">
      <img src="@/assets/logo.png" alt="depa" class="join-logo" />
      <div class="join-check">
        <v-icon color="white" size="34">mdi-check</v-icon>
      </div>
      <h1 class="join-title">{{ texts.title }}</h1>
      <p class="join-welcome">{{ texts.welcome(attendee) }}</p>
      <!-- ชื่อการประชุม + เวลา: แสดงเฉพาะประเภท "การประชุม" -->
      <div v-if="showMeetingBox" class="join-meeting">
        <div class="join-meeting-title">{{ meeting.title }}</div>
        <div class="join-meeting-time">
          <v-icon small color="primary">mdi-calendar-clock</v-icon>
          {{ meetingTime }}
        </div>
      </div>
    </div>

    <!-- ลงทะเบียนไม่สำเร็จ -->
    <div v-else-if="page === 'error'" class="join-card">
      <depa-bird :size="64"></depa-bird>
      <h1 class="join-title join-title--error">ลงทะเบียนไม่สำเร็จ</h1>
      <p class="join-welcome">ลองสแกน QR Code อีกครั้ง หากยังไม่ได้ กรุณาติดต่อเจ้าหน้าที่หน้าห้องประชุม</p>
    </div>
  </div>
</template>
<script>
import axios from "axios";

import { API_URL } from '@/config';
import Swal from 'sweetalert2';
import { mapActions } from 'vuex';
import DepaBird from '../components/DepaBird.vue';
import BirdOrbit from '../components/BirdOrbit.vue';
import { joinTexts, typeOf } from '@/meetingType';

export default {
  name: 'CallbackThaid',
  components: { DepaBird, BirdOrbit },
  data() {
    return {
      loading: false ,
      page: 'loading',
      finishing: false,
      meeting: null,
      attendee: '',
    };
  },
  computed: {
    // ข้อความตามประเภท (การประชุม / ลงทะเบียน)
    texts() {
      return joinTexts(this.meeting && this.meeting.type);
    },
    showMeetingBox() {
      return !!this.meeting && typeOf(this.meeting.type) === 'meeting';
    },
    meetingTime() {
      const m = this.meeting;
      if (!m || !m.startdate) return '';
      const date = new Intl.DateTimeFormat('th-TH', { weekday: 'short', day: 'numeric', month: 'short', year: 'numeric' })
        .format(new Date(`${m.startdate}T00:00:00`));
      return `${date} · ${m.starttime || ''}${m.endtime ? `–${m.endtime}` : ''} น.`;
    },
  },
  async mounted() {
    try {


      if (this.$route.query.state == 'login'){
        this.loading = true;
        let res = await axios.get(`${API_URL}/loginThaid`, {
          params: {
            code: this.$route.query.code
          }
        });
        if (res.data.responsecode === 200) {
          this.page = this.$route.query.state;
          this.handlelogin(res.data.user);
        } else if (res.data.responsecode === 500) {
          Swal.fire({
            title: "เข้าสู่ระบบไม่สำเร็จ",
            icon: "warning",
            confirmButtonText: '<span style="padding: 15px" >ปิด</span>',
          });
          this.$router.push('/login');
        }


      }
      else {
        // ผู้เข้าร่วมสแกน QR แล้วยืนยันตัวตนกับ ThaID เสร็จ
        this.page = 'loading';
        let res = await axios.get(`${API_URL}/memberjoin`, {
          params: {
            code: this.$route.query.code,
            state: this.$route.query.state
          }
        });
        if (res.data.responsecode === 200) {
          this.meeting = res.data.meeting || null;
          this.attendee = res.data.attendee || '';
          // ให้นกวนครบรอบแล้วจางหายก่อน (BirdOrbit emit 'done' แล้วค่อยเปลี่ยนเป็นหน้าสำเร็จ)
          this.finishing = true;
        } else {
          this.page = 'error';
        }
      }

    } catch (e) {
      console.error(e.message);
      this.page = 'error';
    }
  },
  methods: {
    ...mapActions(['login']),
    async handlelogin(data) {
      await this.login({ username: data });

      this.$router.push('/listmeeting');
    }
  },
};
</script>
<style scoped>
.join-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px 16px;
  background: linear-gradient(160deg, #0C2F53 0%, #123E6B 100%);
}

.join-card {
  width: 100%;
  max-width: 440px;
  padding: 40px 28px 32px;
  border-radius: 24px;
  background: #FFFFFF;
  box-shadow: 0 16px 48px rgba(0, 0, 0, 0.25);
  text-align: center;
}

.join-logo {
  display: block;
  height: 36px;
  margin: -12px auto 20px;
}

.join-check {
  width: 64px;
  height: 64px;
  margin: 8px auto 12px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #2E9E5B;
  box-shadow: 0 6px 18px rgba(46, 158, 91, 0.35);
  animation: pop 0.5s 0.6s ease-out both;
}

.join-title {
  color: #0C2F53;
  font-size: 28px;
  font-weight: 700;
  margin-bottom: 6px;
}

.join-title--error {
  margin-top: 12px;
  color: #C62828;
}

.join-welcome {
  color: #3C4A5C;
  font-size: 16px;
  white-space: pre-line;
  margin-bottom: 0;
}

.join-meeting {
  margin-top: 18px;
  padding: 14px 16px;
  border-radius: 14px;
  background: #FFF8DC;
  border: 1px solid #FFE58A;
}

.join-meeting-title {
  color: #0C2F53;
  font-size: 18px;
  font-weight: 700;
  line-height: 1.4;
  margin-bottom: 6px;
}

.join-meeting-time {
  color: #5B6B7F;
  font-size: 14px;
}

.join-orbit {
  margin: 0 auto;
}

.join-loading {
  margin-top: 16px;
  color: #0C2F53;
  font-size: 17px;
  font-weight: 600;
}

@keyframes pop {
  from { opacity: 0; transform: scale(0.3); }
  to { opacity: 1; transform: scale(1); }
}

html.no-motion .join-check {
  animation: none;
}
</style>
